import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/vehicleStock.css";

export default function VehicleStock() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const brand = params.get("brand");
  const model = params.get("model");

  const [products, setProducts] = useState([]);
  const [otherModels, setOtherModels] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await API.get(
          `/stock/by-vehicle?brand=${brand}&model=${model}`
        );

        setProducts(res.data?.main || []);
        setOtherModels(res.data?.other || []);
      } catch (err) {
        console.error("Vehicle stock load failed", err);
      }
    };

    if (brand && model) loadData();
  }, [brand, model]);

  return (
    <div className="vehicle-stock-page">

      {/* BACK */}
      <button className="btn-back" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h2 className="vehicle-title">
        {brand} / {model} Products
      </h2>

      {/* SEARCH */}
      <input
        className="search-bar"
        placeholder="Search product..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {/* MAIN PRODUCTS */}
      <div className="stock-section">
        <h3>Main Products</h3>

        {products.length === 0 ? (
          <div className="no-variants">
            No products available for this model
          </div>
        ) : (
          <div className="stock-grid">
            {products
              .filter(p =>
                p.name.toLowerCase().includes(search.toLowerCase())
              )
              .map(p => (
                <div key={p._id} className="stock-card">
                  <div className="stock-desk">Desk {p.desk || 0}</div>

                  <div className="stock-price mt-4">₹{p.price}</div>
                  <div className="stock-name">{p.name}</div>

                  <div className="stock-meta">
                    Brand: {p.brand || "No Selected"}
                  </div>
                  <div className="stock-meta">
                    Model: {p.model || "No Selected"}
                  </div>

                  <div className="stock-qty">
                    Stock: {p.quantity}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* OTHER MODELS */}
      {otherModels.length > 0 && (
        <div className="stock-section">
          <h3>Other Models ({brand})</h3>

          <div className="stock-grid">
            {otherModels.map(p => (
              <div key={p._id} className="stock-card">
                <div className="stock-desk">Desk {p.desk || 0}</div>
                <div className="stock-price mt-4">₹{p.price}</div>
                <div className="stock-name">{p.name}</div>

                <div className="stock-meta">
                  Model: {p.model || "No Selected"}
                </div>

                <div className="stock-qty">
                  Stock: {p.quantity}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
